@let v = version();
<div
    class="flex flex-col space-y-4"
    (focusin)="hoverRow.set(true)"
    (focusout)="hoverRow.set(false)"
    (mouseenter)="hoverRow.set(true)"
    (mouseleave)="hoverRow.set(false)"
>
    <div class="flex items-center justify-between">
        @if (v.inPending && !v.drive) {
            <div class="flex min-w-0 items-center space-x-8">
                <interacta-image
                    classes="size-24 shrink-0"
                    [alt]="''"
                    [src]="v.iconPath || ''"
                />

                <interacta-input-text [control]="control()" />
            </div>
        }

        @if (!v.inPending || v.drive) {
            <a
                class="flex min-w-0 items-center space-x-8"
                target="_blank"
                [attr.href]="
                    v.drive?.webViewLink ??
                        v.temporaryContentViewLink ??
                        v.temporaryContentDownloadLink
                        | storageTemporaryLink$
                        | async
                "
                [ngClass]="{
                    'opacity-50': v.inDeleting,
                }"
            >
                <interacta-image
                    classes="size-24"
                    [alt]="''"
                    [src]="v.iconPath || ''"
                />
                <span
                    class="min-w-0 typo-medium-bold wrap-break-word"
                    [ngClass]="{ 'line-through': v.inDeleting }"
                >
                    {{ v.name || '' }}
                </span>
                @if (v.isCurrentVersion) {
                    <span
                        class="shrink-0 typo-medium-bold"
                        [ngClass]="{
                            'line-through': v.inDeleting,
                        }"
                    >
                        {{
                            'DASHBOARD.ATTACHMENTS.CURRENT_VERSION' | translate
                        }}
                    </span>
                }
            </a>
        }

        <div class="ml-12 flex shrink-0 items-center space-x-12">
            @if (v.uploadProgress && v.uploadProgress < 100) {
                @if (hoverRow()) {
                    <button
                        interacta-icon-button
                        type="button"
                        [icon]="'close'"
                        [label]="'SHARED.FILE_UPLOAD.CANCEL_UPLOAD' | translate"
                        [size]="'small'"
                        [style]="'text'"
                        (click)="cancelUpload.emit()"
                    ></button>
                } @else {
                    <interacta-progress-loader
                        [matTooltip]="v.uploadProgress + '%'"
                        [progress]="v.uploadProgress"
                        [size]="'small'"
                    />
                }
            } @else {
                <interacta-creation-date
                    class="typo-xs text-text-mid-contrast"
                    [date]="v.creationTimestamp ?? now"
                />

                @if (v.inPending) {
                    <button
                        interacta-icon-button
                        type="button"
                        [icon]="'trash-bin'"
                        [label]="'SHARED.BUTTON.DELETE' | translate"
                        [size]="'regular'"
                        [style]="'text'"
                        (click)="removeVersion.emit()"
                    ></button>
                }
            }
        </div>
    </div>

    @if (v.inPending && !v.drive) {
        <interacta-checkbox
            [checked]="useVersionNameForAttachment()"
            (changed)="changeCheck.emit($event === true)"
        >
            <p class="typo-sm">
                {{
                    'DASHBOARD.ATTACHMENTS.VERSIONS.USE_VERSION_NAME'
                        | translate
                }}
            </p>
        </interacta-checkbox>
    }

    @if (!v.isPartial) {
        <div class="flex items-center space-x-8 text-text-mid-contrast">
            <p
                class="typo-sm"
                [ngClass]="{
                    'text-text-primary': v.inPending,
                }"
            >
                {{
                    v.inPending
                        ? ('DASHBOARD.ATTACHMENTS.CURRENT_VERSION_WILL_BE_MAIN'
                          | translate)
                        : v.creatorUser?.fullName
                }}
            </p>
            <p class="typo-xs">
                ({{ v.size ?? 0 | formatBytes }}, {{ mimeType() }})
            </p>
        </div>
    }
</div>
